import {Action} from '@ngrx/store';
import {IUserGlobalServicesState} from '../state/user-global-services.state';

export enum SETTINGS_GLOBAL_SERVICES_ACTION {
  INIT_GLOBAL_SETTINGS_SERVICES = 'INIT_GLOBAL_SETTINGS_SERVICES',
  RESET_GLOBAL_SETTINGS_SERVICES = 'RESET_GLOBAL_SETTINGS_SERVICES',
}

export class SetGlobalSettingsServices implements Action {
  readonly type = SETTINGS_GLOBAL_SERVICES_ACTION.INIT_GLOBAL_SETTINGS_SERVICES;

  constructor(public payload: IUserGlobalServicesState) {}
}

// eslint-disable-next-line max-classes-per-file
export class ResetGlobalSettingsServices implements Action {
  readonly type = SETTINGS_GLOBAL_SERVICES_ACTION.RESET_GLOBAL_SETTINGS_SERVICES;
}

export type GlobalSettingsServicesAction = SetGlobalSettingsServices | ResetGlobalSettingsServices;
